import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getFuelPricing = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-pricing/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel pricing fetch error:", error);
    throw error;
  }
};

const getFuelPricingById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-pricing/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel price fetch error:", error);
    throw error;
  }
};

const createFuelPricing = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-pricing/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel price create error:", error);
    throw error;
  }
};

const updateFuelPricing = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-pricing/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel price update error:", error);
    throw error;
  }
};

const deleteFuelPricing = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-pricing/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel price delete error:", error);
    throw error;
  }
};

const getFuelTypesOffered = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fuel-vendor/fuel-types-offered/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel types offered fetch error:", error);
    throw error;
  }
};

export {
  getFuelPricing,
  getFuelPricingById,
  createFuelPricing,
  updateFuelPricing,
  deleteFuelPricing,
  getFuelTypesOffered,
};
